import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDPaper } from '@facet-wealth/design';

export const PillarActionItemIconNotPrePlan = ({ isDisabled, isCompleted, isOverdue }) => {
  let iconProps;

  if (isDisabled && !isCompleted) {
    iconProps = { icon: 'lockCircleOutline', color: 'textDisabled' };
  } else if (isOverdue) {
    iconProps = { icon: 'error', color: 'error' };
  }

  return iconProps ? (
    <FDPaper appearance={'flat'}>
      <FDIcon {...iconProps} />
    </FDPaper>
  ) : null;
};

PillarActionItemIconNotPrePlan.defaultProps = {
};

PillarActionItemIconNotPrePlan.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  isOverdue: PropTypes.bool.isRequired,
};
